class SimpleSlider extends Component {
    constructor(el) {
        super(el);
        this.mainSwiperEl = this.$find('[data-simple-slider]');
        this.mainSwiper = null;
            this.mainSwiperConfig = {
                slidesPerView: 1,
                loop:true,
                autoplay: {
                  delay: 5000
                },
                navigation: {
                    nextEl: this.$find('[data-swiper-button-next]'),
                    prevEl: this.$find('[data-swiper-button-prev]')
                },
                pagination: {
                    el: this.$find('[data-swiper-pagination]')
                },
                watchOverflow: true
            };
        this.init();
    }

    constructMainSwiper() {
        this.mainSwiper = new Swiper(this.mainSwiperEl, this.mainSwiperConfig);
    }

    init() {
        this.mainSwiperEl && this.constructMainSwiper();
    }
}